// CRC32 for the one-click packages — faithful port of the inverter's C routine
// (Get_Inverter_Version_CRC32 / CRC32). DIFFERENT from the standard reflected
// CRC32 (`computeCRC32`, poly 0xEDB88320) used by the legacy per-module path:
//   - poly 0x04C11DB7, init 0xFFFFFFFF, MSB-first, big-endian word packing,
//     no input/output reflection, no final XOR, special trailing-bytes handling.
// Verified against the reference values (ARM 1944365446, DSPM 3358020844,
// DSPS 2550662785, SAFETY 819451549).

const POLY = 0x04c11db7;

/** Process 32-bit words bit-by-bit (MSB first), replicating the C `CRC32`. */
function crc32Words(curCRC: number, words: number[]): number {
  let uCRC = curCRC >>> 0;
  for (let n = 0; n < words.length; n++) {
    let xbit = 0x80000000;
    const data = words[n] >>> 0;
    for (let bits = 0; bits < 32; bits++) {
      uCRC = (uCRC & 0x80000000) ? (((uCRC << 1) >>> 0) ^ POLY) >>> 0 : (uCRC << 1) >>> 0;
      if (data & xbit) {
        uCRC = (uCRC ^ POLY) >>> 0;
      }
      xbit >>>= 1;
    }
  }
  return uCRC >>> 0;
}

/**
 * CRC32 (inverter variant, `Get_Inverter_Version_CRC32`) over a byte buffer.
 * Packs 4 bytes at a time as a big-endian word, with the original trailing-bytes
 * handling for files whose length is not a multiple of 4. Returns unsigned 32-bit.
 */
export function oneClickCrc32(data: Uint8Array, fileLen: number = data.length): number {
  let hCRC = 0xffffffff >>> 0;

  const fullWords = Math.floor(fileLen / 4);
  const words: number[] = new Array(fullWords);
  for (let i = 0; i < fullWords; i++) {
    const o = i * 4;
    words[i] = ((data[o] << 24) | (data[o + 1] << 16) | (data[o + 2] << 8) | data[o + 3]) >>> 0;
  }
  hCRC = crc32Words(hCRC, words);

  const rem = fileLen % 4;
  if (rem !== 0) {
    const base = fullWords * 4;
    let temp = 0;
    if (rem === 1) {
      temp = data[base];
    } else if (rem === 2) {
      temp = ((data[base] << 8) | data[base + 1]) >>> 0;
    } else if (rem === 3) {
      temp = ((data[base] << 16) | (data[base + 1] << 8) | data[base + 2]) >>> 0;
    }
    hCRC = crc32Words(hCRC, [temp >>> 0]);
  }

  return hCRC >>> 0;
}
